:host {
  display: block;
}

.help-text {
  font-size: 10px;
  color: #708090;
}

.search-results {
  margin-top:  8px;
  width:  100%;
}

.pagination-controls {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}

cr-universal-search {
  margin-top: 2px;
}

cr-modal::part(modal) {
  top: 25%;
  transform: translate(-50%, 0%);
  width: 50%;
}

cr-universal-search::part(search-input) {
  width: 100%;
}

cr-universal-search::part(search-field) {
  width: 100%;
}

cr-universal-search::part(search-input-field) {
  width: 100%;
  padding: 4px;
}

cr-universal-search::part(suggestion) {
  height: 24px;
  padding: 4px;
  border-radius: 4px;
}

cr-universal-search::part(suggestion):hover {
  background-color: #FFFFF0;
}

cr-universal-search::part(suggestion-link) {
  text-decoration: none;
  color: #708090;
}

cr-universal-search::part(highlighted-suggestion-link) {
  text-decoration: underline;
  color: #000000;
}

cr-universal-search::part(suggestion-link):hover {
  text-decoration: underline;
  color: #000000;
}

cr-universal-search::part(suggestions-list-error) {
  padding: 4px;
  font-size: 10px;
  color: #DC143C;
  font-style:  italic;
}

cr-universal-search::part(suggestions-list-no-results), cr-universal-search::part(suggestions-list-progress) {
  padding: 4px;
  font-size: 10px;
  font-style:  italic;
}